<template>
  <div>
    <PageHeader
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <FilterManager
      v-model="this.filterModel"
      :filters="filtersHeader"
      :display-advanced="false"
      @search="onSearch"
      @saloon="updateFiltersData('saloon', $event, 'onSaloonTypeChanged')"
      @category="updateFiltersData('category', $event, 'onCategoryChanged')"
    />
    <Separator class="my-3" text="Resultado de Catálogo" />
    <CustomResultNotFound v-if="searchResult.data.length === 0" />
    <ResultRow
      v-for="item in searchResult.data"
      :key="`row-item-${item.classroomType.id}-${item.category.id}`"
      ref="resultRow"
      :value="item"
      @deleteCatalog="onDeleteCatalog"
    />
    <Pagination
      v-if="
        searchResult.pagination.totalItemCount > searchResult.pagination.perPage
      "
      :page-size="searchResult.pagination.perPage"
      :data="searchResult.pagination"
      @pagination-go-page="onPageChanged"
    />
  </div>
</template>
<script>
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import Separator from 'custom-separator';
import ResultRow from './components/ResultRow';
import alert from '@/mixin/alert.mixin';
import materialsService from '@/services/api/materialsEquipment.api.js';
import {
  getCatalogSearchResult,
  hasNewRequestsBySaloon,
  deleteSaloon,
} from '@/modules/materials-equipment/api.js';

export default {
  name: 'MainMaterialsEquipmentCatalog',
  components: {
    PageHeader,
    CustomResultNotFound,
    Separator,
    FilterManager,
    Pagination,
    ResultRow,
  },
  mixins: [alert],
  data: () => ({
    page: {
      icon: 'fas fa-user-edit',
      title: 'Catálogo de Materiales y Equipos',
      routes: ['Inicio', 'PEI', 'Catálogo de Materiales y Equipos'],
    },
    collections: {
      saloonTypes: [],
      categories: [],
      items: [],
    },
    filterModel: {
      saloon: null,
      category: null,
      item: null,
    },
    searchResult: {
      data: [],
      pagination: {
        perPage: 20,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    },
    regionDisabled: false,
    categoryDisabled: false,
    itemDisabled: false,
  }),
  computed: {
    filtersHeader() {
      return [
        {
          name: 'saloon',
          component: 'CustomDropDown',
          options: this.collections.saloonTypes,
          value: this.filterModel.saloon,
          placeholder: 'Seleccione Tipo de Salón',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          classContainer: 'w-100',
        },
        {
          name: 'category',
          component: 'CustomDropDown',
          options: this.collections.categories,
          value: this.filterModel.category,
          placeholder: 'Seleccione Categoría',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          classContainer: 'w-100',
        },
        {
          name: 'item',
          component: 'CustomDropDown',
          options: this.collections.items,
          value: this.filterModel.item,
          placeholder: 'Seleccione Artículo',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          classContainer: 'w-100',
        },
      ];
    },
  },
  async mounted() {
    this.fetchSaloonTypes();
  },
  methods: {
    updateFiltersData(key, event, callback) {
      if (event != undefined && event != null && event != '') {
        this.filterModel[key] = event;
      } else {
        this.filterModel[key] = null;
      }

      if (callback != undefined) {
        if (typeof this[callback] == 'function') {
          this[callback](event);
        }
      }
    },
    async fetchSaloonTypes() {
      const { data } = await materialsService.getSaloonTypes();
      this.collections.saloonTypes = data;
    },
    async fethCategories(saloon) {
      const { data } = await materialsService.getCategories({
        saloonId: saloon.id,
      });

      this.collections.categories = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filterModel.category = data[0];
      }
    },
    async fetchItems(category) {
      const { data } = await materialsService.getItemTypes({
        saloonId: this.filterModel.saloon.id,
        categoryId: category.id,
      });

      this.collections.items = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filterModel.item = data[0];
      }
    },
    async onSaloonTypeChanged(saloon) {
      this.filterModel.category = null;
      this.filterModel.item = null;

      this.collections.categories = [];
      this.collections.items = [];

      await this.fethCategories(saloon);
    },
    async onCategoryChanged(category) {
      this.filterModel.item = null;

      this.collections.items = [];

      await this.fetchItems(category);
    },
    async onSearch(filters, page = 1) {
      const mappedFilter = {
        saloonId: filters.saloon?.id,
        categoryId: filters.category?.id,
        articleId: filters.item?.id,
        pageIndex: page,
        pageSize: this.searchResult.pagination.perPage,
      };

      await getCatalogSearchResult(mappedFilter).then((res) => {
        this.searchResult.data = res.data.data;
        this.searchResult.pagination = {
          ...this.searchResult.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    async onPageChanged(currentPage) {
      this.searchResult.pagination.currentPage = currentPage;
      await this.onSearch(this.filters, currentPage);
    },
    async onDeleteCatalog(value) {
      let self = this;
      let currentPage = this.searchResult.pagination.currentPage;
      await hasNewRequestsBySaloon(value.classroomType?.id).then((res) => {
        if (res.data) {
          self.ShowToast(
            'Alerta',
            `Para eliminar el tipo de salón, debe eliminar el salón de las solicitudes en estatus Nuevo.`,
            'error'
          );
        } else {
          self
            .ShowCancelModal(
              'Alerta',
              `¿Usted está seguro que desea eliminar el tipo de salón "${value.classroomType.name}"?`,
              'Sí',
              'No'
            )
            .then((res) => {
              if (res) {
                deleteSaloon(value.classroomType?.id, value.category?.id).then(
                  () => {
                    this.onSearch(this.filterModel, currentPage);
                    self.ShowToast(
                      'Proceso Exitoso',
                      'El tipo de salón ha sido eliminado exitosamente.',
                      'success'
                    );
                  }
                );
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped></style>
